import { render, staticRenderFns } from "./FormSepaMandate.vue?vue&type=template&id=2e6f3586&scoped=true&"
import script from "./FormSepaMandate.vue?vue&type=script&lang=ts&"
export * from "./FormSepaMandate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f3586",
  null
  
)

export default component.exports